import {
  requestMSALocations,
  receiveMSALocations,
  handleMSALocationsError,
} from './actions';
import {Services} from 'core';
import * as TYPES from './constants';
import {API} from 'config/superuser.config';

const services = new Services();
const initialState = {
  data: null,
  error: null,
  request: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_MSA_LOCATIONS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_MSA_LOCATIONS:
      return {
        ...state,
        data: action.payload || null,
        request: false,
        error: false,
      };
    case TYPES.MSA_LOCATIONS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchMSALocations = key => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  dispatch(requestMSALocations());
  let endpoint = `${API.administration.msa_locations}?msa_location=true`;
  if (key) {
    endpoint += `&location_name=${key}`;
  }
  try {
    return services
      .fetchRecords(endpoint, token)
      .then(res => {
        dispatch(receiveMSALocations(res));
      })
      .catch(err => console.log(err));
  } catch (err) {
    console.log(err);
    dispatch(handleMSALocationsError(err));
  }
};
